'use strict';

angular.module('mobile-apps').controller('UpgradeSubscriptionNotOwnerModalController', [
	'$scope',
	'Authentication',
	'Utilities',
	'ModalData',
	'TeamNotification',
	'$modalInstance',
	function (
		$scope,
		Authentication,
		Utilities,
		ModalData,
		TeamNotification,
		$modalInstance
	) {
		$scope.authentication = Authentication;

		$scope.owner = ModalData.owner;

		$scope.processing = false;

		$scope.sendNotification = function() {
			$scope.processing = true;

			TeamNotification.send({
				_id: ModalData.teamId,
				requestingUser: ModalData.currentUser._id,
				exceededProperty: ModalData.exceededProperty
			}, function(result) {
				$scope.processing = false;

				$modalInstance.close({});

				Utilities.showMessage(
					'Success!',
					'The upgrade notification got successfully sent to the owner of the team!',
					'success'
				);
			}, function(error) {
				$scope.processing = false;

				Utilities.showMessage(
					'Problem!',
					'There was a problem sending the notification!\nPlease try again later or inform support.\n\nThanks!',
					'error'
				);

			});

		};

		/**
		 * Close modal
		 */
		$scope.close = function() {
			$modalInstance.dismiss();
		};
	}
]);

